
/**
 * TODO: Add undefined checks and percision limits.
 */
export function toPixel (number) {
  return `${number}px`
}

/**
 * Needed because of Chrome doesn't show proper mobile innerWidth in dev tools.
 */
export function getViewportWidth () {
  return Math.min(window.innerWidth, window.outerWidth)
}

export function getViewportHeight () {
  return window.innerHeight
}
